<template>
  <div>
    <div class="payment-page">
      <div v-if="show">
        <div class="tops">
          <div class="rmb" style="color: #00c6ff">
            ₹{{ form.orderAmount ? form.orderAmount.toFixed(2) : "" }}

            <van-icon
              v-if="form.orderAmount"
              class="iconCopy"
              name="column"
              size="14pt"
              style="margin-left: 3px"
              @click="copyText(2)"
            />
          </div>
          <div class="timer">
            <van-count-down
              :style="
                time == '999999999999999'
                  ? 'color: #fff;font-size: 1.3rem;'
                  : 'font-size: 1.3rem;'
              "
              format="mm:ss"
              :time="time"
              @finish="onFinish"
            />
          </div>
        </div>
        <p class="showOneTxt" style="margin-bottom: 12px">
          Tip: Please make sure your payment amount is consistent with the order
          amount, otherwise your order may fail
        </p>
        <div class="main">
          <div class="idBox">
            <div class="idBoxName">UPI ID:</div>
            <div class="idBoxNum">
              <p style="color: #da2f2f; font-size: 12pt">
                {{ form.upiAccount ? form.upiAccount : "" }}
              </p>

              <div @click="copyUpiId">
                <div
                  class="idBoxBtn"
                  @click="copyText(1)"
                  :style="!copyUPIFlag ? 'background: #e7e7e7' : ''"
                >
                  Copy UPI
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="payment-info">
          <div style="margin-top: 30pt">
            <van-image
              width="154pt"
              height="154pt"
              fit="fill"
              :src="formattedQrCode"
            />
          </div>
        </div>
        <p class="test1" @click="noFlase">How to Find Your UTR</p>
        <p class="test2">Payment by UPI ID transfer,NOT MOBILE NUMBER</p>

        <div class="inputBox">
          <p style="font-size: 12pt; margin-right: 0.66rem; color: #999999">
            UTR
          </p>
          <van-field
            style="
              border: 1px solid #bababa;
              height: 2.2rem;
              line-height: 2.2rem;
              padding: 0 0.6rem;
              border-radius: 2px;
            "
            v-model="utrValue"
            placeholder="input 12 digits here"
            input-align="left"
          />
          <van-button
            class="inputBoxBtnCss"
            v-debounce="submitPayment"
            :style="!inputBoxBtnFlag ? 'background: #e7e7e7' : ''"
            >Submit</van-button
          >
        </div>

        <p class="text3">
          Important reminder: After completing the UPl transaction,please
          backfll RefNo,/UTR No./Google Pay : UPl Transaction lD/Freecharge:
          Transaction lD(12digits). lf you do not back fll UTR, 100% of the
          deposit transaction will fail. Please be sure to backf!!!
        </p>

        <div class="footerBox">
          <div class="footerBoxTwos"><div></div></div>
          <div class="footerBoxText">
            Warning: Please confirm that the accountinformation is correct and
            use the accountto pay, otherwise the above payment will not be
            completed correctly!
          </div>
        </div>
      </div>
      <div v-else>
        <div class="sBox" v-if="status == 'wait'">
          <!-- <van-image width="100" height="100" :src="require('../assets/时间@2x.png')" />
          <p class="sp">
            The payment result is being confirmed<br/> Please wait patiently.
          </p> -->
          <div v-if="orderStatus == ''" class="sBox">
            <div class="circle">
              <div class="dots">
                <div
                  v-for="n in 8"
                  :key="n"
                  class="dot"
                  :style="getDotStyle(n)"
                ></div>
              </div>
              <div class="countdown">
                {{ countdown }}
              </div>
            </div>
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: 400;
                text-align: center;
                font-size: 15px;
                color: #333333;
              "
            >
              UTR submitted successfully and <br />
              is being confirmed
            </p>
          </div>
          <div v-if="orderStatus == 1" class="sBox">
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: bold;
                font-size: 24px;
                color: #70cf40;
                margin-bottom: 20px;
              "
            >
              <!-- ₹{{ form.orderAmount }} -->
            </p>
            <van-image
              width="100"
              height="100"
              :src="require('../assets/success@2x.png')"
            />
            <p class="sp">Your payment is successful!</p>
          </div>

          <div v-else class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/时间@2x.png')"
            />
            <p class="sp">
              The payment result may be delayed,<br />
              we will process it within 10 minutes
            </p>
          </div>
        </div>
      </div>
      <div class="sBox" v-if="status == 'promptTwo'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">{{ h5PayOrderQueryMsg }}</p>
      </div>

      <div class="sBox" v-if="status == 'timeout'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">Payment timed out, please try again</p>
      </div>
      <div class="sBox" v-if="status == 'err'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">{{ msg }}</p>
      </div>
      <div class="sBox" v-if="status == 'prompt'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          Payment submission is successful, please wait patiently for the
          payment result
        </p>
      </div>
    </div>

    <div class="dBox" v-if="dialogFlag">
      <div class="nos" @click="noFlase">X</div>
      <div>
        <p>MobiKwik</p>
        <img src="@/assets/to1.jpg" alt="" />
        <p>Freecharge</p>
        <img src="@/assets/to2.jpg" alt="" />
        <p>Gpay</p>
        <img src="@/assets/to3.jpg" alt="" />
        <p>PayTM</p>
        <img src="@/assets/to4.jpg" alt="" />
        <p>PhonePe</p>
        <img src="@/assets/to5.jpg" alt="" />
      </div>
    </div>

    <div class="loadingBox" v-if="loadingFlag">
      <div
        style="
          margin-top: 50vh;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 14px;
          margin-left: 50vw;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- 旋转类型+文字 -->
        <van-loading type="spinner" style="color: #fff" vertical
          >loading...</van-loading
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  h5CashRegisterGetUpi,
  h5CopyUpi,
  h5CheckOutUtrSubmit,
  h5PayOrderQuery,
} from "@/api";
import { Button, Dialog } from "vant";

import Vue from "vue";
Vue.use(Button);
import { Icon } from "vant";
Vue.use(Icon);
import { Field } from "vant";
Vue.use(Field);
import { CountDown } from "vant";
Vue.use(CountDown);
import { Image as VanImage } from "vant";
Vue.use(VanImage);
import { Toast } from "vant";
Vue.use(Toast);

import Clipboard from "clipboard";

export default {
  data() {
    return {
      time: "999999999999999",
      status: "默认",
      upiId: "",
      utrValue: "",
      headers: {
        "X-Plat-Order-Id": this.$route.query.orderId,
        "X-Sign": this.$route.query.sign, // 使用组件中的动态值
      },
      form: {},
      show: true,
      countdown: 10,
      interval: null,
      orderStatus: "",

      dialogFlag: false,
      msg: "",

      copyUPIFlag: true,
      inputBoxBtnFlag: true,

      h5PayOrderQueryMsg: "",

      upiAccount: "12345",

      maxRetries: 1,

      loadingFlag: false,
      toJumpUrl: "",
    };
  },
  methods: {
    noFlase() {
      this.dialogFlag = !this.dialogFlag;
    },
    getDotStyle(index) {
      const angle = index * 45 * (Math.PI / 180); // 每个点之间的角度
      const radius = 30; // 半径
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return {
        transform: `translate(${x}px, ${y}px)`,
        animation: `dot-animation 1.4s ease-in-out infinite ${index * 0.1}s`,
      };
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          if (
            this.countdown == 9 ||
            this.countdown == 6 ||
            this.countdown == 3
          ) {
            this.getStatus();
          }
        } else {
          clearInterval(this.interval);
          this.getStatus();
        }
      }, 3000);
    },
    async getStatus() {
      const res = await h5PayOrderQuery(
        {
          platOrderId: this.$route.query.orderId,
        },
        {
          "X-Plat-Order-Id": this.$route.query.orderId,
          "X-Sign": this.$route.query.sign,
        }
      );

      if (res.status) {
        clearInterval(this.interval);
        this.orderStatus = res.status;
      }

      if (res.status == 1 || res.status == 3) {
        clearInterval(this.interval);
      }

      if (res.jumpUrl != "") {
        this.toJumpUrl = res.jumpUrl;
      }

      // 订单失败处理
      if (res.status == 3) {
        this.show = false;
        this.status = "err";
        this.msg = "Payment failed";
        return;
      }

      // 订单成功处理
      if (res.status == 1) {
        if (this.toJumpUrl != "") {
          window.open(this.toJumpUrl, "_blank");
        }
        this.show = false;
        this.status = "promptTwo";
        this.h5PayOrderQueryMsg = "Order successful";
        return;
      }

      if (res.status == 2 && this.countdown == 0) {
        this.orderStatus = 8;
      }
    },
    async getInfo() {
      const res = await h5CashRegisterGetUpi(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      );

      if (res.status == "635") {
        if (this.maxRetries < 3) {
          this.maxRetries++;
          this.loadingFlag = true;

          setTimeout(async () => {
            return await this.getInfo();
          }, 1500);
          return;
        }

        this.loadingFlag = false;
        this.show = false;
        this.status = "err";
        this.msg = "Please refresh the page and try again.";
        return;
      }

      // 链接已经被调起
      if (res.status == 3 && this.show != false) {
        Dialog.confirm({
          title: "prompt",
          message: "Have you completed the payment?",
          confirmButtonText: "Not paid yet", //取消按钮
          cancelButtonText: "Paid", //确定按钮
        })
          .then(() => {
            if (this.toJumpUrl != "") {
              window.open(this.toJumpUrl, "_blank");
            }
          })
          .catch(() => {
            this.show = false;
            this.status = "prompt";
          });
      }

      // 异常处理
      if (res.status == 600 || res.status == 620) {
        this.show = false;
        this.status = "err";
        this.msg = res.message;
        return;
      }

      this.form = res;

      this.calculateTimeDifference(res.expireTime);
    },

    onFinish() {
      this.show = false;
      this.status = "timeout";
    },

    calculateTimeDifference(params) {
      // 获取当前印度时间的 Date 对象
      const currentTime = (() => {
        const indianTimeString = new Date().toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        });
        return new Date(indianTimeString);
      })();

      // console.log('当前印度时间 (Date 对象):', currentTime)
      // 订单有效时间
      const expireTime = new Date(params.replace(" ", "T"));

      // 计算时间差，单位为毫秒
      const timeDifference = expireTime - currentTime;

      // 将结果赋值给 time
      this.$nextTick(() => {
        this.time = timeDifference;
      });
    },

    copyUpiId() {
      if (this.copyUPIFlag == false) {
        return false;
      }

      this.copyUPIFlag = false;

      h5CopyUpi({ platOrderId: this.form.platOrderId }, this.headers).then(
        (res) => {
          this.copyUPIFlag = true;
          try {
            this.upiAccount = res.upiAccount;
          } catch (err) {
            this.$toast.fail("Copy failed, please try again!");
            console.error("复制失败：", err);
          }
        }
      );
      // .catch((err) => {
      //   this.show = false;
      //   Toast.fail('This order has expired');
      // });
    },

    submitPayment() {
      if (!this.utrValue) {
        Toast.fail("Please enter the UTR.");
        return;
      }
      // if (this.utrValue.length < 10 || this.utrValue.length > 18) {
      //   this.$toast.fail('The length must be between 10-18 digits')
      //   return
      // }
      if (!/^\d{12}$/.test(this.utrValue)) {
        this.$toast.fail(
          "UTR format error:UTR is a 12-digit combination, please check carefully"
        );
        return;
      }

      if (this.inputBoxBtnFlag == false) {
        return false;
      }

      this.inputBoxBtnFlag = false;

      h5CheckOutUtrSubmit(
        {
          platOrderId: this.form.platOrderId,
          utr: this.utrValue,
        },
        this.headers
      )
        .then((res) => {
          this.show = false;
          if (this.toJumpUrl != "") {
            window.open(this.toJumpUrl, "_blank");
          }
          this.status = "wait";
          this.inputBoxBtnFlag = true;
          this.startCountdown();
        })
        .catch((err) => {
          this.inputBoxBtnFlag = true;
          Toast.fail(err.message);
        });
    },
    setRootFontSize() {
      const baseSize = 16; // 基准字体大小
      const scale = document.documentElement.clientWidth / 375; // 375 为设计稿宽度
      document.documentElement.style.fontSize =
        baseSize * Math.min(scale, 2) + "px"; // 限制缩放倍数
    },

    copyText(num) {
      setTimeout(() => {
        // Create and append the fake button first
        const fakeBtn = document.createElement("button");
        fakeBtn.className = num == 1 ? "copy-btn" : "iconCopy";
        fakeBtn.style.display = "none";
        document.body.appendChild(fakeBtn);

        // Initialize Clipboard.js after the button exists in DOM
        const clipboard = new Clipboard(fakeBtn, {
          text: () =>
            num == 1 ? this.upiAccount : this.form.orderAmount.toFixed(2),
        });

        clipboard.on("success", (e) => {
          this.$toast.success("Replicating Success!");
          e.clearSelection();
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        clipboard.on("error", (e) => {
          this.$toast.error("Copy failed!");
          clipboard.destroy();
          document.body.removeChild(fakeBtn);
        });

        // Trigger click after everything is set up
        fakeBtn.click();
      }, 500);
    },
  },
  computed: {
    formattedQrCode() {
      // 动态拼接前缀
      return `data:image/png;base64,${this.form.qrCode}`;
    },
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.setRootFontSize();
    window.addEventListener("resize", this.setRootFontSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setRootFontSize);
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.payment-page {
  min-height: 100vh;
  padding: 1rem;
}

.tops {
  display: flex;
  justify-content: space-between;
  font-size: 18pt;
  margin-bottom: 0.5rem;
}
.timer {
  color: #111111;
}
.main {
}
.idBoxName {
  color: #999999;
  font-size: 12pt;
}

.idBox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.idBoxNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.test1 {
  text-align: center;
  color: #ed810e;
  margin-bottom: 15pt;
}
.test2 {
  text-align: center;
  margin-bottom: 15pt;
  color: #111111;
}

.inputBox {
  display: flex;
  align-items: center;
  margin: 2.47rem 0 1rem;
}

.text3 {
  color: #ff3600;
  text-align: center;
  font-size: 12pt;
  line-height: 1.09rem;
  margin-bottom: 1.81rem;
}

.footerBox {
  display: flex;
  border: 0.03px solid #bfbfbf;
  border-radius: 0.31rem;
}

.footerBoxTwos {
  width: 50%;
  background: #00c6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  border: 0.03px solid #00c6ff;
  border-top-left-radius: 4pt;
  border-bottom-left-radius: 4pt;
}

.footerBoxTwos div {
  width: 1.8rem;
  height: 2.5rem;
  border: 3px solid #fff;
  background: #00c6ff;
}

.footerBoxText {
  font-size: 12pt;
  color: #00c6ff;
  padding: 0.8rem;
  line-height: 1.09rem;
}

.payment-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.6rem;
  border-radius: 0.6rem;
  background-color: #fff;
  margin-bottom: 0.69rem;
}

.idBoxBtn {
  text-align: center;
  width: 68pt;
  border-radius: 0.19rem;
  border: 0.06px solid #00c6ff;
  color: #00c6ff;
  font-size: 12pt;
  padding: 0.5rem;
  margin-left: 0.56rem;
}

.amount {
  font-size: 2rem;
  font-weight: bold;
  color: #ff6600;
  text-align: center;
  margin-bottom: 1rem;
}
.utr-input-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #fff;
  padding: 8px 16px;
  border-radius: 0.6rem;
}

/* UTR Label */
.utr-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.utr-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #27ae60; /* 绿色 */
}

.utr-text {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

/* 输入框 */
.utr-input {
  background: #f5f5f5;
  border-radius: 8px;
}

.utr-input .van-field__control {
  font-size: 14px;
  color: #888888;
}
.title-container {
  width: 100%;
  padding-top: 20px;
}

.title {
  font-size: 1.3rem;
  position: relative;
  display: inline-block;
  color: #000; /* 标题文字的颜色 */
}

.title span {
  display: inline-block;
  position: relative;
  z-index: 1; /* 确保文字在背景色之上 */
}

.title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; /* 控制绿色背景的高度 */
  background-color: #66cc33; /* 背景色 */
  z-index: 0; /* 确保背景色在文字下面 */
}
.tb {
  background-color: #fff;
  border-radius: 1.2rem;
  padding: 1rem;
  margin-top: 1rem;
}
.image-container {
  margin-top: 1rem;
  margin-bottom: 2rem;
  border-radius: 1rem;
}
.jump-button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  animation: jump 1s infinite alternate; /* 添加动画 */
}

/* 定义跳动动画 */
@keyframes jump {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-10px);
  }
}
.sBox {
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sp {
  margin-top: 20px;
  font-family: Source Sans Variable;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
}
.circle {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 2.4s infinite linear;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  position: absolute;
}

.countdown {
  position: absolute;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-animation {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.dBox {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20pt;
  width: 100vw; /* 固定宽度 */
  height: 100vh; /* 固定高度 */
  overflow: auto; /* 自动显示滚动条 */
}

.dBox img {
  width: 100%;
}

.nos {
  position: fixed;
  top: 0;
  right: 0;
  width: 36pt;
  height: 36pt;
  border-radius: 18pt;
  text-align: center;
  line-height: 40pt;
  background: #fff;
  font-size: 22px;
}

.dBox p {
  margin: 20px 0;
  font-size: 22px;
}

.showOneTxt {
  font-size: 0.8rem;
  color: #ff9b00 !important;
  margin-bottom: 1.3rem;
  line-height: 1.4rem;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 0.5rem;
}

.inputBoxBtnCss {
  width: 4.31rem;
  margin-left: 6px;
  background-color: #00c6ff;
  color: #fff;
  height: 2.3rem;
  line-height: 2.3rem;
  font-size: 12pt;
}

.loadingBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(#ccc, #ccc, #ccc, 0.8);
  top: 0;
  left: 0;
}
</style>
